import {Theme, createStyles} from '@material-ui/core';
import {StyleRules} from '@material-ui/core/styles';

const trackingTableFooterStyles = (_theme: Theme): StyleRules =>
	createStyles({});

export default trackingTableFooterStyles;
